import React, { useState } from 'react';
import { MailIcon, PhoneIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const MAIL_ENDPOINT = 'https://scan.noorddigital.nl/mail.php';
export const ContactForm: React.FC = () => {
  const [form, setForm] = useState({
    voornaam: '',
    achternaam: '',
    email: '',
    telefoon: '',
    bericht: ''
  });
  const [status, setStatus] = useState<'idle' | 'sending' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');
  function handleChange(e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) {
    setForm({
      ...form,
      [e.target.name]: e.target.value
    });
  }
  async function handleSubmit() {
    if (!form.voornaam.trim() || !form.email.trim() || !form.telefoon.trim() || !form.bericht.trim()) {
      setErrorMsg('Vul alle verplichte velden in.');
      return;
    }
    setErrorMsg('');
    setStatus('sending');
    try {
      const body = new URLSearchParams({
        naam: `${form.voornaam.trim()} ${form.achternaam.trim()}`.trim(),
        email: form.email.trim(),
        telefoon: form.telefoon.trim(),
        bericht: form.bericht.trim(),
        ontvanger: 'info@noorddigital.nl',
        onderwerp: `Nieuw contactformulier Noord Digital van ${form.voornaam.trim()}`
      });
      const res = await fetch(MAIL_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: body.toString()
      });
      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      setStatus('success');
    } catch (e: any) {
      setStatus('error');
      setErrorMsg('Versturen mislukt. Probeer opnieuw of mail info@noorddigital.nl.');
    }
  }
  return <section id="contact" className="w-full bg-gradient-to-r from-[#007AFF] to-[#1B2B44] py-20 md:py-32 relative overflow-hidden" data-id="element-198" data-mp="3kmv8rc0sgwfk">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-[1200px] relative z-10" data-id="element-199" data-mp="vwc8cca487x5">
        {/* Header */}
        <div className="mb-16 max-w-3xl" data-id="element-200" data-mp="2wwh3vxailgvn">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-201" data-mp="2wvfqhm610iar">
            Klaar voor de volgende stap in online groei?
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-white/90 text-lg" data-id="element-202" data-mp="30yvlyf6d0clv">
            Plan een vrijblijvend gesprek! We bekijken samen welke aanpak past
            bij jouw bedrijf en groeifase.
          </motion.p>
        </div>

        {/* Card Container */}
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="bg-white rounded-3xl overflow-hidden flex flex-col lg:flex-row shadow-2xl" data-id="element-203" data-mp="1uh8kefe07ozp">
          {/* Left Column */}
          <div className="bg-[#EBF3FF] p-8 md:p-12 lg:w-5/12 flex flex-col" data-id="element-204" data-mp="9t62919io5gw">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hNQXPwX8APxFUETyhYjjKE/Mogelijk_voor_website_%2837%29.jpg" alt="Rocco" className="w-full aspect-[4/5] object-cover rounded-2xl mb-8 shadow-sm border border-white/50" data-id="element-205" data-mp="3s6nf2ah3qwi8" />
            <h3 className="text-4xl font-bold text-[#111827] mb-4" data-id="element-206" data-mp="omrg259rsxfj">
              Geïnteresseerd?
            </h3>
            <p className="text-[#4B5563] mb-8 leading-relaxed" data-id="element-207" data-mp="so4kqc14mukv">
              Vul het formulier in en we nemen snel contact met je op om je
              project te bespreken.
            </p>
            <div className="space-y-4 mb-12" data-id="element-208" data-mp="jrlvpaw0nqtk">
              <div className="flex items-center gap-4" data-id="element-209" data-mp="2zfvobsit302a">
                <div className="w-10 h-10 rounded-full bg-[#007AFF] flex items-center justify-center flex-shrink-0" data-id="element-210" data-mp="2zj9oqv7wsz73">
                  <MailIcon className="w-5 h-5 text-white" data-id="element-211" data-mp="3jpes3ogqps8l" />
                </div>
                <a href="mailto:info@noorddigital.nl" className="text-[#111827] font-medium hover:text-[#007AFF] transition-colors" data-id="element-212" data-mp="3eyycbxpg5uj2">
                  info@noorddigital.nl
                </a>
              </div>
              <div className="flex items-center gap-4" data-id="element-213" data-mp="35yiaesocqvgb">
                <div className="w-10 h-10 rounded-full bg-[#007AFF] flex items-center justify-center flex-shrink-0" data-id="element-214" data-mp="360364lmekkfr">
                  <PhoneIcon className="w-5 h-5 text-white" data-id="element-215" data-mp="6h0qcwhkjbzm" />
                </div>
                <a href="tel:+31653689686" className="text-[#111827] font-medium hover:text-[#007AFF] transition-colors" data-id="element-216" data-mp="2ib6cl20yw70">
                  +31 6 53689686
                </a>
              </div>
            </div>
            <p className="text-[10px] text-[#6B7280] mt-auto leading-tight" data-id="element-217" data-mp="3oqua17nmfimr">
              Uw gegevens zijn bij ons veilig en worden uitsluitend gebruikt om
              u te helpen naar aanleiding van dit formulier
            </p>
          </div>

          {/* Right Column */}
          <div className="bg-white p-8 md:p-12 lg:w-7/12 relative" data-id="element-218" data-mp="2377f5gswx55w">
            {/* Dots */}
            <div className="absolute top-8 right-8 flex gap-1.5" data-id="element-219" data-mp="2858w9w6s2ueq">
              {['#004AC7', '#007AFF', '#66A3FF'].map((color, i) => <motion.div key={color} className="w-3 h-3 rounded-full" style={{
              backgroundColor: color
            }} animate={{
              y: [0, -6, 0],
              opacity: [0.6, 1, 0.6]
            }} transition={{
              duration: 1.6,
              repeat: Infinity,
              ease: 'easeInOut',
              delay: i * 0.2
            }} data-id="element-220" data-mp="2d1qx4kyzm8ls" data-mpi={i} />)}
            </div>

            {status === 'success' ? <div className="flex flex-col items-center justify-center h-full py-16 text-center" data-id="element-221" data-mp="30teg8gq0cfdi">
                <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mb-6" data-id="element-222" data-mp="11gag8mhlm6aq">
                  <svg className="w-8 h-8 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-223" data-mp="16f3qm61l9h6o">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" data-id="element-224" data-mp="ydw5imjnxmwj" />
                  </svg>
                </div>
                <h3 className="text-2xl font-bold text-[#111827] mb-3" data-id="element-225" data-mp="thpavpwpvxtw">
                  Bericht verzonden!
                </h3>
                <p className="text-[#4B5563]" data-id="element-226" data-mp="13e1zi9denlhs">
                  We nemen zo snel mogelijk contact met je op.
                </p>
              </div> : <div className="space-y-6 mt-4 md:mt-0" data-id="element-227" data-mp="1hc8rj8voar9j">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-228" data-mp="1ceqg9bu6nzyd">
                  <div data-id="element-229" data-mp="1ccdzh205vvmw">
                    <label className="block text-sm font-medium text-[#4B5563] mb-2" data-id="element-230" data-mp="1r33eygknnwwk">
                      Voornaam <span className="text-red-500" data-id="element-231" data-mp="1m49xye65tnrn">*</span>
                    </label>
                    <input type="text" name="voornaam" value={form.voornaam} onChange={handleChange} className="w-full bg-[#F7F8FA] border border-gray-200 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#007AFF] focus:border-transparent transition-all" placeholder="Voornaam" data-id="element-232" data-mp="1m6mhgvrkg66t" />
                  </div>
                  <div data-id="element-233" data-mp="2jpky5ts0nq1f">
                    <label className="block text-sm font-medium text-[#4B5563] mb-2" data-id="element-234" data-mp="2jos0rjey6cvy">
                      Achternaam
                    </label>
                    <input type="text" name="achternaam" value={form.achternaam} onChange={handleChange} className="w-full bg-[#F7F8FA] border border-gray-200 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#007AFF] focus:border-transparent transition-all" placeholder="Achternaam" data-id="element-235" data-mp="25s694q5odk9z" />
                  </div>
                </div>

                <div data-id="element-236" data-mp="1n0dekrayjr05">
                  <label className="block text-sm font-medium text-[#4B5563] mb-2" data-id="element-237" data-mp="1n158zystjiou">
                    Email <span className="text-red-500" data-id="element-238" data-mp="1r1yw4pyfstgo">*</span>
                  </label>
                  <input type="email" name="email" value={form.email} onChange={handleChange} className="w-full bg-[#F7F8FA] border border-gray-200 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#007AFF] focus:border-transparent transition-all" placeholder="je.naam@voorbeeld.nl" data-id="element-239" data-mp="1d14m62vqqkfw" />
                </div>

                <div data-id="element-240" data-mp="1sjxi8exs0xoc">
                  <label className="block text-sm font-medium text-[#4B5563] mb-2" data-id="element-241" data-mp="1shb9wd32ae52">
                    Je telefoonnummer <span className="text-red-500" data-id="element-242" data-mp="1ojx1uor4acen">*</span>
                  </label>
                  <input type="tel" name="telefoon" value={form.telefoon} onChange={handleChange} className="w-full bg-[#F7F8FA] border border-gray-200 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#007AFF] focus:border-transparent transition-all" placeholder="06 53689686" data-id="element-243" data-mp="1jig5n6jkve4e" />
                </div>

                <div data-id="element-244" data-mp="14rh064e1h5p1">
                  <label className="block text-sm font-medium text-[#4B5563] mb-2" data-id="element-245" data-mp="10shzivzcbv3e">
                    Beschrijf wat we voor je kunnen doen{' '}
                    <span className="text-red-500" data-id="element-246" data-mp="vsltysazvvlq">*</span>
                  </label>
                  <textarea name="bericht" rows={4} value={form.bericht} onChange={handleChange} className="w-full bg-[#F7F8FA] border border-gray-200 rounded-lg px-4 py-3 focus:outline-none focus:ring-2 focus:ring-[#007AFF] focus:border-transparent transition-all resize-none" placeholder="Vertel wat we voor je kunnen betekenen..." data-id="element-247" data-mp="qv3l11wz9gdq" />
                </div>

                {errorMsg && <p className="text-red-500 text-sm" data-id="element-248" data-mp="3ghoueymapyhj">{errorMsg}</p>}

                <button type="button" onClick={handleSubmit} disabled={status === 'sending'} className="w-full bg-[#007AFF] hover:bg-[#005FCC] disabled:opacity-60 text-white font-semibold py-4 rounded-xl transition-colors text-lg mt-4" data-id="element-249" data-mp="3gf2k4r80t4vm">
                  {status === 'sending' ? 'Versturen...' : 'Verstuur'}
                </button>
              </div>}
          </div>
        </motion.div>
      </div>
    </section>;
};